/**
 * Loan Drilldown → Chat tab.
 *
 * Real-time team chat for the open loan, backed by the `/chat` router and the
 * shared Web PubSub socket (see useLoanChat). Separate from the formal comment
 * thread — fast, informal team back-and-forth scoped to one loan.
 *
 * Thin wrapper around the shared LoanChatPanel (also used by the floating chat
 * widget). The header carries a toggle to show/hide the floating chat bubble —
 * the place to re-enable it after hiding it from the bubble itself. Gated by
 * loanChatAccess.canSeeLoanChat (nav entry + route both check it).
 */
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

import LoanChatPanel from "./LoanChatPanel";
import { useLoanChatFabHidden } from "./useLoanChatFabHidden";

// Switch toggles whether the floating chat bubble shows on loan pages. The hook
// stores "hidden", so the switch is checked (on) when the bubble is visible.
function BubbleToggle() {
  const [hidden, setHidden] = useLoanChatFabHidden();
  const visible = !hidden;
  return (
    <Tooltip
      title={
        visible
          ? "Floating chat bubble is on — turn off to hide it on loan pages"
          : "Floating chat bubble is off — turn on to show it on loan pages"
      }
    >
      <Box
        component="label"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: 12,
          fontWeight: 600,
          color: "#475569",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        Chat bubble
        <Switch
          size="small"
          checked={visible}
          onChange={(e) => setHidden(!e.target.checked)}
          inputProps={{ "aria-label": "Toggle floating chat bubble" }}
        />
      </Box>
    </Tooltip>
  );
}

export default function LoanDrilldownChatTab() {
  return (
    <LoanChatPanel
      subtitle="team thread for this loan — separate from comments"
      headerActions={<BubbleToggle />}
    />
  );
}
